import { FsTeamSource } from "db/model/tournament/Segment/Bracket/FsTeamSource";
import { TeamSource } from "model/Bracket/TeamSource";
import { nonUndefined } from "Utility";

export const mapTeamSources = (fsModels: FsTeamSource[]): TeamSource[] => {
  return nonUndefined(fsModels.map(mapTeamSource));
};

const mapTeamSource = (fsModel: FsTeamSource): TeamSource | undefined => {
  if (!fsModel.source) {
    return undefined;
  }

  return {
    source: fsModel.source,
    position: fsModel.position ?? -1,
  };
};
